export default __webpack_public_path__ + "static/media/1863.51a45aaa.png";